export default {
  circleHlt: {
    borderRadius: "50%",
    color: "#007155",
    fontSize: "70px",
    fontFamily: "Oswald",
    height: "210px",
    width: "210px",
    display: "block",
    marginLeft: "15px",
    marginRight: "auto",
    marginTop: "-40px",
    position: "relative"
  },
  faqHiltTextCircle: {
    lineHeight: "26px",
    color: "#01533F",
    ffontFamily: "Oswald",
    textAlign: "center",
    display: "inline-block",
    fontWeight: "500",
    textTransform: "uppercase",
    marginBottom: "0.2em"
  }
};
